import { useState } from 'react'

import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'
import { GqlError } from 'src/lib/gql-client'
import useSWR from 'swr'

import {
  GenerateNetworkProbeVideoCallTokenReturn,
  generateNetworkProbeVideoCallToken,
} from '../api/generateConnectionTestVideoCallToken'

type State = {
  videoCallRoomUid: string
  agoraCloudProxyMode: 'Auto' | 'ForceUDP' | 'ForceTCP'
  outboundToken: string
  outboundVideoCallUserUid: number
  inboundToken: string
  inboundVideoCallUserUid: number
}

export const useConnectionTestVideoCallToken = ({
  canUseVideoCallTest,
}: {
  canUseVideoCallTest: boolean
}) => {
  const [state, setState] = useState<State>()

  const toast = useMirohaToast()

  useSWR<GenerateNetworkProbeVideoCallTokenReturn, GqlError>(
    !!state || !canUseVideoCallTest
      ? null
      : 'generateNetworkProbeVideoCallToken',
    generateNetworkProbeVideoCallToken,
    {
      onSuccess: data => {
        setState({
          videoCallRoomUid: data.videoCallRoomUid,
          agoraCloudProxyMode: data.agoraCloudProxyMode,
          outboundToken: data.outboundToken,
          outboundVideoCallUserUid: data.outboundVideoCallUserUid,
          inboundToken: data.inboundToken,
          inboundVideoCallUserUid: data.inboundVideoCallUserUid,
        })
      },
      onError: error => {
        toast({
          status: 'error',
          title: error.message,
        })
      },
      errorRetryCount: 1,
    },
  )

  return state
}
